export default "__VITE_ASSET__BZroPQfw__"